import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M214.433 56c18.475-32 64.663-32 83.138 0l180.133 312c18.476 32-4.619 72-41.569 72H75.869c-36.951 0-60.045-40-41.57-72zm41.569 88L131.294 360h249.415z"
    }, null, -1)
  ]))]))
}
export default { render: render }